import { render } from "./InventoryOverview.vue?vue&type=template&id=36296054&scoped=true"
import script from "./InventoryOverview.vue?vue&type=script&lang=js"
export * from "./InventoryOverview.vue?vue&type=script&lang=js"

import "./InventoryOverview.vue?vue&type=style&index=0&id=36296054&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36296054"]])

export default __exports__